import React, {Fragment, useState} from 'react';
import {Tag, Icon} from '@blueprintjs/core';

import {Table, Row, Cell} from '/src/components/tables/table'


const ItemRow = (
    {
        elems,
        setShapeHighlight,
        lineContext,
        deleteContext,
        editItem,
        getActionType,
    }) => {
    const [showButtons, setShowButtons] = useState(false);

    const lines = lineContext.actions && !!elems?.curves
        ? elems.curves.filter(curve => {
            return !!lineContext.actions.find(action => {
                return action[0].lineId === curve.name;
            });
        })
        : [];

    return (
        <Row
            key={lineContext.id}
            $hoverColor="#d7e4f7"
            onMouseOver={() => {
                setShowButtons(true);
                lines.forEach(line => setShapeHighlight(line, true));
            }}
            onMouseLeave={() => {
                setShowButtons(false);
                lines.forEach(line => setShapeHighlight(line, false));
            }}
        >
            <Cell span={2} halign="center" valign="center">
                <Tag>{lineContext.type}</Tag>
            </Cell>
            <Cell span={3} haligh="center" valign="center">
                <Table>
                    {lineContext.actions.map((action, actionIndex) => {
                        if (!action[0] || !action[1]) return null;
                        const actionsTuple = [action[0], action[1]];
                        const actionType = getActionType(actionsTuple);
                        return (
                            <Row key={actionIndex}>
                                <Cell halign="right" valign="center">
                                    <Tag intent="primary">{`${action[0].lineId}`}</Tag>
                                </Cell>
                                <Cell halign="left" valign="center">
                                    <Tag>{actionType ? actionType : ''}</Tag>
                                </Cell>
                            </Row>
                        )
                    })}
                </Table>
            </Cell>
            <Cell span={3} haligh="center" valign="center">
                {(lineContext.type === 'within-location-entry' || lineContext.type === 'within-location-pass-by') &&
                    lineContext.metadata && (
                        <Table>
                            {lineContext.metadata.map((metadataItem, index) => (
                                <Row key={index}>
                                    <Cell halign="right" valign="center">
                                        <Tag intent="primary">{metadataItem.key}</Tag>
                                    </Cell>
                                    <Cell halign="left" valign="center">
                                        <Tag>{metadataItem.value}</Tag>
                                    </Cell>
                                </Row>
                            ))}
                        </Table>
                    )
                }
            </Cell>
            <Cell span={1} halign="right" valign="center" gap="5px">
                {showButtons && (
                    <Fragment>
                        <Icon
                            icon="edit"
                            htmlTitle="Edit"
                            intent="success"
                            onClick={() => editItem(lineContext)}
                        />
                        <Icon
                            icon="trash"
                            htmlTitle="Delete"
                            intent="danger"
                            onClick={() => deleteContext(lineContext)}
                        />
                    </Fragment>
                )}
            </Cell>
        </Row>
    );
};

export {ItemRow};

